import React from "react";
import SidebarFiltersComponent from "./sidebar-filters.component";

const SidebarFiltersContainer = (props: any) => {
  return <SidebarFiltersComponent {...props} />;
};

export default SidebarFiltersContainer;
